import type { CoolingRegimeTemperatureDto } from "../../../RoyalFloraHolland.Aap.Services.Api.Web.Kiota/Typescript/Api/models/index";

export interface TemperatureRow {
  coolingRegimeTemperatureId: number;
  description: string;
  lastModified: string;
  lastModifiedBy: string;
  created: Date | null;
  createdBy: string;
  actions?: any;
}

function formatDateToString(date: Date | null | undefined): string {
  if (!date) return "-";
  const dateObj = new Date(date);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
}

export function mapCoolingRegimeTemperatureDtoToRow(
  dto: CoolingRegimeTemperatureDto,
): TemperatureRow {
  return {
    coolingRegimeTemperatureId: dto.coolingRegimeTemperatureId || 0,
    description: dto.description || "-",
    lastModified: formatDateToString(dto.lastModified),
    lastModifiedBy: dto.lastModifiedBy || "-",
    created: dto.created ? new Date(dto.created) : null,
    createdBy: dto.createdBy || "-",
  };
}

export function mapCoolingRegimeTemperatureDtoArrayToRows(
  dtos: CoolingRegimeTemperatureDto[],
): TemperatureRow[] {
  return dtos.map(mapCoolingRegimeTemperatureDtoToRow);
}
